import React, { useState } from 'react';
import './Section_1.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";  
import "slick-carousel/slick/slick-theme.css";  
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button className="slider-arrow next-arrow" onClick={onClick}>
      ❯
    </button>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button className="slider-arrow prev-arrow" onClick={onClick}>
      ❮
    </button>
  );
}

function Section1({ heroConfig, onOpenSurvey }) {
  const [showSurvey, setShowSurvey] = useState(false);

  const backgroundStyle = getBackground(heroConfig.bg_color);
  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    speed: 1000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const hasImages = heroConfig.images && heroConfig.images.length > 0;

  const handleButtonClick = (button) => {
    if (button.path === "\/") {
      setShowSurvey(true);
    } else {
      window.location.href = button.path;
    }
  };

  const handleCloseSurvey = () => {
    setShowSurvey(false);
  };

  return (
    <>
      <section className="hero-section" style={{ position: "relative" }}>
        {/* Background Slider */}
        <div className="hero-background">
          {hasImages ? (
            <Slider {...sliderSettings}>
              {heroConfig.images.map((img, index) => (
                <div key={index}>
                  <img src={img} alt={`slide-${index}`} className="hero-slide" />
                </div>
              ))}
            </Slider>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100vh",
                background: backgroundStyle,
              }}
            />
          )}
        </div>

        {/* Foreground content */}
        <div className="hero-content" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
          <h1>{heroConfig.title}</h1>
          <p>{heroConfig.subtitle}</p>
          <div className="hero-buttons">
            {heroConfig.buttons.map((button, index) => (
              <button
                key={index}
                className="hero-button"
                onClick={() => handleButtonClick(button)}
              >
                {button.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}

function getBackground(bgColors) {
  if (!bgColors || bgColors.length === 0) return "#FFF";
  return bgColors.length === 1
    ? bgColors[0]
    : `linear-gradient(90deg, ${bgColors.join(", ")})`;
}

export default Section1;
